import { createSelector } from 'reselect'
import { selectApplication } from './selectApplication'

export const selectIsRightSidebarCollapsed = createSelector(
  selectApplication,
  app => app.isRightSidebarCollapsed
)
